import { Component, inject, OnInit, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../components/button/button.component';
import { CustomerInfoComponent } from "../../../../components/customer-info/customer-info.component";
import { PHONE_NUMBER_MASK } from '../../../../constants';
import { HeadService } from '../../../../services/head.service';
import { LanguageService } from '../../../../services/language/language.service';
import { ResetPasswordModalComponent } from '../reset-password-modal/reset-password-modal.component';


@Component({
  selector: 'account-customer-info',
  templateUrl: './account-customer-info.component.html',
  styleUrls: ['./account-customer-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, ButtonComponent, CustomerInfoComponent],
})
export class AccountCustomerInfoComponent implements OnInit {
  private headService = inject(HeadService);
  private destroyRef = inject(DestroyRef);
  private languageService = inject(LanguageService);
  private readonly dialog = inject(MatDialog);

  ngOnInit(): void {
    this.setMeta();
  }

  changePassword(): void {
    this.dialog.open(ResetPasswordModalComponent);
  }

  private setMeta() {
    this.languageService.getTranslation('account_customer_info.account')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(text => {
        this.headService.setMeta({ title: text, description: text });
      });
  }

  protected readonly PHONE_NUMBER_MASK = PHONE_NUMBER_MASK;
}
